import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { Flex } from 'foundations-components/components/Flex';
import { List } from 'foundations-components/transitional/components/List';
import { HR } from 'foundations-components/transitional/components/HR';
import { Button } from 'foundations-components/transitional/components/Button';
import { TranscriptContext } from '../../contexts/TranscriptContext';
import { View } from 'foundations-components/components/View';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MatchPopoverBody = ({
  onParticipantClick,
  selectedParticipant,
  onMapClick
}) => {
  const {
    transcriptParticipants,
    setIsMatchingPopoverOpen
  } = useContext(TranscriptContext);
  const filteredParticipants = transcriptParticipants.filter(participant => participant.mappedSpeakerTrackId === null || participant.mappedSpeakerTrackId === undefined);
  const handleCancelClick = evt => {
    evt.stopPropagation();
    setIsMatchingPopoverOpen(false);
  };
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "matchPopoverBody",
    maxInlineSize: "250px",
    children: [/*#__PURE__*/_jsx(List, {
      margin: "0",
      padding: "0",
      children: filteredParticipants && filteredParticipants.map(participant => /*#__PURE__*/_jsx(SelectableBox, {
        block: true,
        type: "default",
        "data-test-id": "matchPopoverBody_participantSelectable",
        padded: false,
        selectionMarkLocation: "left",
        marginBlockEnd: "200",
        marginInlineStart: "0",
        padding: "200",
        selected: selectedParticipant && selectedParticipant.participantId === participant.participantId,
        onClick: () => onParticipantClick(participant),
        children: /*#__PURE__*/_jsx(Text, {
          as: "div",
          textAlign: "start",
          children: /*#__PURE__*/_jsx(TruncateString, {
            children: participant.participantName
          })
        })
      }, participant.participantId))
    }), /*#__PURE__*/_jsx(HR, {
      distance: "sm"
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      paddingBlockEnd: "300",
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "matchPopoverBody_matchButton",
        use: "tertiary",
        size: "small",
        onClick: onMapClick,
        disabled: selectedParticipant === undefined,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "recordingReviewComponents.participantMatching.matchPopover.match"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        size: "small",
        onClick: handleCancelClick,
        "data-test-id": "matchPopoverBody_cancelButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "recordingReviewComponents.participantMatching.matchPopover.cancel"
        })
      })]
    })]
  });
};